import * as ActionTypes from 'constants';

const integrations = (state = {
    jobnimbus_auth_error: false,
  }, action) => {
  const { type, payload } = action;

  switch(type) {
    case ActionTypes.TOGGLE_JOB_NIMBUS_AUTH_ERROR:
      return { ...state, jobnimbus_auth_error: payload != null ? payload : !state.jobnimbus_auth_error };
  }

  return state;
};

export { integrations };



// WEBPACK FOOTER //
// ./src/common/reducers/integrations.js